import { useTranslation } from 'react-i18next';

import WarningModal, { type WarningModalProps } from '~molecules/WarningModal';

type MaterialChangeModalProps = Pick<
  WarningModalProps,
  'onCancel' | 'onConfirm'
> & { materialName: string | undefined };

const MaterialChangeModal = ({
  materialName,
  onCancel,
  onConfirm,
}: MaterialChangeModalProps) => {
  const { t } = useTranslation();

  const modalTitle = `${t(
    'SCROLLABLE_AREA.MATERIAL.CONFIRMATION_MODAL.TITLE'
  )} ${materialName ?? ''}?`;
  const modalDescription = t(
    'SCROLLABLE_AREA.MATERIAL.CONFIRMATION_MODAL.DESCRIPTION'
  );
  const buttons = {
    cancel: t('SCROLLABLE_AREA.MATERIAL.CONFIRMATION_MODAL.BUTTON_CANCEL'),
    confirm: t('SCROLLABLE_AREA.MATERIAL.CONFIRMATION_MODAL.BUTTON_CONFIRM'),
  };

  return (
    <WarningModal
      title={modalTitle}
      description={modalDescription}
      buttons={buttons}
      isVisible={Boolean(materialName)}
      onCancel={onCancel}
      onConfirm={onConfirm}
    />
  );
};

export default MaterialChangeModal;
